(() => {
  if (customElements.get('vg-buy-action')) return;

  class VillaGoBuyAction extends HTMLElement {
    connectedCallback() {
      if (this.labelObserver) return;
      this.labelObserver = new MutationObserver(() => this.enhanceLabel());
      this.labelObserver.observe(this, { childList: true, subtree: true });
      this.enhanceLabel();
    }

    disconnectedCallback() {
      this.labelObserver?.disconnect();
      this.labelObserver = null;
    }

    enhanceLabel() {
      const template = this.querySelector('template[data-vg-buy-label]');
      const sourceLabel = template?.content.querySelector('.vg-buy-now-label');
      if (!sourceLabel || !template.content.querySelector('svg.vg-buy-coin')) return;

      // Enhance only Shopify's current light-DOM fallback; wallets stay native.
      this.querySelectorAll('shopify-buy-it-now-button > button.shopify-payment-button__button--unbranded')
        .forEach((button) => {
          const label = button.querySelector('.vg-buy-now-label');
          const icon = button.querySelector('svg.vg-buy-coin[data-vg-buy-icon]');
          if (icon && label?.textContent === sourceLabel.textContent) return;

          const content = template.content.cloneNode(true);
          content.querySelectorAll('svg').forEach((svg) => {
            svg.setAttribute('data-vg-buy-icon', '');
            svg.setAttribute('aria-hidden', 'true');
            svg.setAttribute('focusable', 'false');
          });

          // Keep the exact button, native handler and all availability attributes.
          // Shopify can replace its children on re-render, so inspect actual nodes.
          button.replaceChildren(content);
        });
    }
  }

  customElements.define('vg-buy-action', VillaGoBuyAction);
})();
